module.exports = __webpack_public_path__ + "img/login_page.f1a7bb35.png";